<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yXYy8u/tc-custom/9780253062109.jpg?1721451107789" alt="This image is the cover for the book Father of Jewish Mysticism, New Jewish Philosophy and Thought"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Father of Jewish Mysticism, New Jewish Philosophy and Thought
      </h1>
      <p class="bookDescription body article font2">
        <p><i>The Father of Jewish Mysticism</i> offers an incisive look at the early life and writings of Gershom Scholem (1897–1982), the father of modern Jewish mysticism and a major 20th-century Jewish intellectual. </p><p>Daniel Weidner offers the first full-length study, published in English, of Scholem's thought. Scholem, a historian ofthe Kabbalah and sharp critic of Jewish assimilation, played a major role in the study and popularization of Jewish mysticism.</p><p>Through his work on the Kabbalah, Scholem turned the closed world of mystical texts into a force for Jewish identity. Skillfully drawing on Scholem's early diaries and writings, <i>The Father of Jewish Mysticism</i> introduces a young, soon-to-be legendary intellectual in search of himself and Judaism.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Daniel Weidner, Sage Anderson
      </h2>
      
      <p class="authorDescription body article"><P>Daniel Weidner is Professor of Comparative Literature at Martin Luther University of Halle-Wittenberg. He is the author of <I>Bibel und Literatur um 1800 </I>and editor of the <I>Handbuch Literatur und Religion, Blumenberg Lesen: Ein Glossar</I>, and <I>Profanes Leben: Walter Benjamins Dialektik der Säkularisierung</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6992e352